var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("MonthPickerDialog", {
        attrs: { viewModel: _vm.benefitsConfidenceDateMonthPicker },
        on: { "update-date": _vm.handleUpdateBenefitsConfidenceDate },
      }),
      _vm._v(" "),
      _c("CorporateNavigation", { attrs: { ActivePage: "portfolios" } }),
      _vm._v(" "),
      _vm.rm
        ? _c(
            "div",
            {
              staticClass: "container",
              staticStyle: { "margin-top": "80px", "padding-top": "40px" },
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("hr", {
                staticStyle: { "border-color": "#bbb", margin: "20px 0 60px" },
              }),
              _vm._v(" "),
              _c(
                "form",
                {
                  attrs: { id: "portfolio-settings-form" },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.handleUpdatePortfolioSettingsCommand.apply(
                        null,
                        arguments
                      )
                    },
                  },
                },
                [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("Portfolio name:")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.name,
                          expression: "name",
                          modifiers: { trim: true },
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        required: "",
                        maxlength: "100",
                        minlength: "2",
                      },
                      domProps: { value: _vm.name },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.name = $event.target.value.trim()
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "error" }, [
                      _vm._v(_vm._s(_vm.nameError)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("Description:")]),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.description,
                          expression: "description",
                          modifiers: { trim: true },
                        },
                      ],
                      staticClass: "form-control",
                      domProps: { value: _vm.description },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.description = $event.target.value.trim()
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-row" }, [
                    _c("div", { staticClass: "col-lg-6" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [_vm._v("End of benefits confidence:")]),
                        _vm._v(" "),
                        _vm.benefitsConfidenceDate == null
                          ? _c("div", { staticClass: "input-group" }, [
                              _c("input", {
                                staticClass: "form-control",
                                attrs: { type: "text", readonly: "" },
                                domProps: { value: `Not defined` },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "input-group-append" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-outline-secondary",
                                    attrs: { type: "button" },
                                    on: {
                                      click:
                                        _vm.showBenefitsConfidenceDateMonthPicker,
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-regular fa-calendar",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                  ]
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.benefitsConfidenceDate != null
                          ? _c("div", { staticClass: "input-group" }, [
                              _c("input", {
                                staticClass: "form-control",
                                attrs: { type: "text", readonly: "" },
                                domProps: {
                                  value: _vm.benefitsConfidenceDateLabel,
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "input-group-append" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-outline-secondary",
                                    attrs: { type: "button" },
                                    on: {
                                      click:
                                        _vm.showBenefitsConfidenceDateMonthPicker,
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-regular fa-calendar",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                  ]
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("h4", [_vm._v("Revenues:")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row mt-3" },
                    _vm._l(_vm.rm.Revenues, function (r) {
                      return _c(
                        "div",
                        { key: r.Id, staticClass: "col-md-4 col-lg-4 mt-1" },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-block text-left",
                              class: r.IsLinked
                                ? "btn-outline-success"
                                : "btn-light",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleLinkage(r)
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fa-regular",
                                class: r.IsLinked
                                  ? "fa-square-check"
                                  : "fa-square",
                              }),
                              _vm._v(
                                "\n                        " +
                                  _vm._s(r.Name) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("h4", [_vm._v("Resources:")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row mt-3" },
                    _vm._l(_vm.rm.Resources, function (r) {
                      return _c(
                        "div",
                        { key: r.Id, staticClass: "col-md-4 col-lg-4 mt-1" },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-block text-left",
                              class: r.IsLinked
                                ? "btn-outline-success"
                                : "btn-light",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleLinkage(r)
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fa-regular",
                                class: r.IsLinked
                                  ? "fa-square-check"
                                  : "fa-square",
                              }),
                              _vm._v(
                                "\n                        " +
                                  _vm._s(r.Name) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("h4", [_vm._v("Expense accounts:")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row mt-3" },
                    _vm._l(_vm.rm.Expenses, function (r) {
                      return _c(
                        "div",
                        { key: r.Id, staticClass: "col-md-4 col-lg-4 mt-1" },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-block text-left",
                              class: r.IsLinked
                                ? "btn-outline-success"
                                : "btn-light",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleLinkage(r)
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fa-regular",
                                class: r.IsLinked
                                  ? "fa-square-check"
                                  : "fa-square",
                              }),
                              _vm._v(
                                "\n                        " +
                                  _vm._s(r.Name) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("h4", [_vm._v("Capex accounts:")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row mt-3" },
                    _vm._l(_vm.rm.Capex, function (r) {
                      return _c(
                        "div",
                        { key: r.Id, staticClass: "col-md-4 col-lg-4 mt-1" },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-block text-left",
                              class: r.IsLinked
                                ? "btn-outline-success"
                                : "btn-light",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleLinkage(r)
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fa-regular",
                                class: r.IsLinked
                                  ? "fa-square-check"
                                  : "fa-square",
                              }),
                              _vm._v(
                                "\n                        " +
                                  _vm._s(r.Name) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("br"),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-6" }, [
        _c(
          "h1",
          {
            staticStyle: {
              "font-size": "2em",
              "font-weight": "300",
              color: "#33475b",
              margin: "0",
            },
          },
          [_vm._v("Settings")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-6 text-right align-self-end" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-outline-secondary",
            staticStyle: { padding: "0.7em 2em" },
            attrs: { type: "submit", form: "portfolio-settings-form" },
          },
          [_vm._v("Save settings")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }